/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Home_Multipleoffers1Inputs */

const id_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Banyak Penawaran`)
};

const ms_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Pelbagai Tawaran`)
};

const da_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Flere Tilbud`)
};

const de_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Mehrere Angebote`)
};

const en_us2_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Multiple Offers`)
};

const es_es2_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Varias versiones`)
};

const es_mx2_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Múltiples ofertas`)
};

const fil_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Maramihang Offer`)
};

const fr_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} — Offres multiples`)
};

const it_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Offerte multiple`)
};

const hu_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Több ajánlat`)
};

const nl_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Meerdere aanbiedingen`)
};

const no_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Flere tilbud`)
};

const pl_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Wiele ofert`)
};

const pt_br2_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Várias versões`)
};

const pt_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Múltiplas ofertas`)
};

const ro_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Oferte multiple`)
};

const fi_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Useita tarjouksia`)
};

const sv_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Flera erbjudanden`)
};

const vi_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Nhiều ưu đãi`)
};

const tr_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Birden Fazla Teklif`)
};

const cs_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Více nabídek`)
};

const bg_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Множество оферти`)
};

const ru_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} — несколько предложений`)
};

const uk_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - Кілька пропозицій`)
};

const ar_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - عروض متعددة`)
};

const hi_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - एकाधिक ऑफ़र`)
};

const th_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - หลายข้อเสนอ`)
};

const ja_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - 複数オファー`)
};

const zh_cn2_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - 多个目录项`)
};

const zh_hant1_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - 多個目錄項目`)
};

const ko_home_multipleoffers1 = /** @type {(inputs: Home_Multipleoffers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - 여러 오퍼`)
};

/**
* | output |
* | --- |
* | "{title} - Multiple Offers" |
*
* @param {Home_Multipleoffers1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_multipleoffers1 = /** @type {((inputs: Home_Multipleoffers1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Multipleoffers1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_multipleoffers1(inputs)
	if (locale === "ms") return ms_home_multipleoffers1(inputs)
	if (locale === "da") return da_home_multipleoffers1(inputs)
	if (locale === "de") return de_home_multipleoffers1(inputs)
	if (locale === "en-US") return en_us2_home_multipleoffers1(inputs)
	if (locale === "es-ES") return es_es2_home_multipleoffers1(inputs)
	if (locale === "es-MX") return es_mx2_home_multipleoffers1(inputs)
	if (locale === "fil") return fil_home_multipleoffers1(inputs)
	if (locale === "fr") return fr_home_multipleoffers1(inputs)
	if (locale === "it") return it_home_multipleoffers1(inputs)
	if (locale === "hu") return hu_home_multipleoffers1(inputs)
	if (locale === "nl") return nl_home_multipleoffers1(inputs)
	if (locale === "no") return no_home_multipleoffers1(inputs)
	if (locale === "pl") return pl_home_multipleoffers1(inputs)
	if (locale === "pt-BR") return pt_br2_home_multipleoffers1(inputs)
	if (locale === "pt") return pt_home_multipleoffers1(inputs)
	if (locale === "ro") return ro_home_multipleoffers1(inputs)
	if (locale === "fi") return fi_home_multipleoffers1(inputs)
	if (locale === "sv") return sv_home_multipleoffers1(inputs)
	if (locale === "vi") return vi_home_multipleoffers1(inputs)
	if (locale === "tr") return tr_home_multipleoffers1(inputs)
	if (locale === "cs") return cs_home_multipleoffers1(inputs)
	if (locale === "bg") return bg_home_multipleoffers1(inputs)
	if (locale === "ru") return ru_home_multipleoffers1(inputs)
	if (locale === "uk") return uk_home_multipleoffers1(inputs)
	if (locale === "ar") return ar_home_multipleoffers1(inputs)
	if (locale === "hi") return hi_home_multipleoffers1(inputs)
	if (locale === "th") return th_home_multipleoffers1(inputs)
	if (locale === "ja") return ja_home_multipleoffers1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_multipleoffers1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_multipleoffers1(inputs)
	return ko_home_multipleoffers1(inputs)
});
export { home_multipleoffers1 as "home.multipleOffers" }